// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"assets_js_Mixins_cookie-consent_js":1,"assets_js_Mixins_animations_js":1,"assets_js_Mixins_carousel_js":1,"assets_js_Mixins_video_js":1,"assets_js_Mixins_forms_js":1}[chunkId]) return "assets/js/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};